import { motion, useReducedMotion } from "framer-motion";

// Fade + slide up on scroll into view.
export const Reveal = ({ children, delay = 0, y = 30, className = "", ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

// Masked line-by-line reveal for headings. Pass an array of lines.
// Layout-safe: outer span always renders at its natural height so nothing
// jumps. Descender-safe padding stops "y/g/p" from being clipped by the
// overflow-hidden mask. Respects prefers-reduced-motion.
export const KineticHeading = ({ lines = [], className = "", lineClassName = "", once = true }) => {
  const reduce = useReducedMotion();
  return (
    <span className={className}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.15em]">
          <motion.span
            className={`block ${lineClassName}`}
            initial={reduce ? { y: "0%" } : { y: "110%" }}
            animate={{ y: "0%" }}
            transition={{ duration: reduce ? 0 : 0.9, delay: reduce ? 0 : 0.15 + i * 0.12, ease: [0.22, 1, 0.36, 1] }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
};

// Same masked reveal but triggered on scroll (whileInView).
export const KineticHeadingInView = ({ lines = [], className = "", lineClassName = "" }) => {
  const reduce = useReducedMotion();
  return (
    <span className={className}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.15em]">
          <motion.span
            className={`block ${lineClassName}`}
            initial={reduce ? { y: "0%" } : { y: "110%" }}
            whileInView={{ y: "0%" }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: reduce ? 0 : 0.85, delay: reduce ? 0 : i * 0.1, ease: [0.22, 1, 0.36, 1] }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
};
